'use strict';

import Api from 'services/api';
import Dispatcher from 'dispatcher/TngAppDispatcher';
import constants from 'constants/appConstants';
import * as authContext from 'services/authContext';

const AuthActionCreators = {

    pageMounted() {
        authContext.checkForToken();
    },

    pageReady(isNewSignIn) {
        let user = null;
        const profile = authContext.getCurrentUser();
        if (profile && authContext.getToken) {
            user = {
                profile,
            };
        }

        Dispatcher.handleAction({
            actionType: constants.actions.PAGE_LOADED,
            data: {user},
        });

        if (isNewSignIn) {
            Dispatcher.handleAction({
                actionType: constants.actions.LOGIN,
            });
        }
    },

    signUp(token) {
        authContext.signUp(token);
    },

    completeSignUp() {
        authContext.completeSignUp();
    },

    login(loginHint) {
        authContext.login(loginHint);
    },

    logout() {
        authContext.logOut();
    },

    sessionEnded() {
        authContext.clearSession();
    },


    signInError() {
        Dispatcher.handleAction({
            actionType: constants.actions.PAGE_LOADED,
            data: {signInError: true},
        });

    },
    getUserIdp(email) {
        Api.AUTH.getUserIdp(email);
    },
    getMigrationUrl(migrationModel) {
        Api.WORKSPACE_MIGRATION.getMigrationUrl(migrationModel);
    },
};

export default AuthActionCreators;
